import React from 'react';
import PropTypes from 'prop-types';
import CircleIcon from '../CircleIcon';
import CircleDotIcon from '../CircleDotIcon';

const LocationType = ({ tripType, selectedType, onTypeChange }) => {
  const tripTypes = [
    { id: 'direct', label: tripType.id == 'from-cruise' ? 'From cruise ship' : 'To cruise ship' },
    { id: 'another-location', label: `${tripType.id == 'from-cruise' ? 'From' : 'To'} another location` }
  ];

  return (
    <div className="text-left mb-3 p-2 mr-4 flex-wrap rounded-md">
      {tripTypes.map((type) => (
        <div key={type.id}>
          <div 
            onClick={() => onTypeChange(type.id)}
            className={
              `cursor-pointer ${selectedType === type.id ? 
                'border-b-2 bg-[#EDEDED]' : 
                ''} cursor-pointer w-full mr-2 ml-2 p-4 flex-wrap inline-flex rounded-md`
            }
          >
            <div className="flex flex-shrink-0 mr-2">
            {selectedType === type.id ? (
              <CircleDotIcon width="20" />
            ) : (
              <CircleIcon width="20" />
            )}
            </div>
            <div className="flex">{type.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

LocationType.propTypes = {
  tripType: PropTypes.object.isRequired,
  selectedType: PropTypes.string.isRequired,
  onTypeChange: PropTypes.func.isRequired
}

export default LocationType;
